import React, { useEffect, useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import axios from 'axios';
import { Tooltip, OverlayTrigger } from 'react-bootstrap'; 
import break_box from '../../../../images/product/break_box.png';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css'; 
import { Link } from "react-router-dom"; 

const EditMenuItem = ({ show, onClose, selectedDate, selectedSno }) => {
   const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    // End Icon
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [groupedProducts, setGroupedProducts] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [productInfo, setProductInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [productImage, setProductImage] = useState(null);

  const forcedProductId = 2;
  const forcedItemIds = [1, 2, 3];

  useEffect(() => {
    const fetchEditData = async () => {
      try {
        if (!show || !selectedSno || !selectedDate) return;

        const formattedDate = selectedDate.toLocaleDateString('sv-SE');

        const { data } = await axios.get(`${baseURL}/menumaker/${selectedSno}`);
        const menuData = data.data;

        if (!menuData || !Array.isArray(menuData.products) || menuData.products.length === 0) return;

        const currentProduct = menuData.products[0];
        const currentProductId = currentProduct?.product_id;

        if (!currentProductId) return;

        setProductInfo({
          product_id: currentProductId,
          product_name: currentProduct.product_name || '',
          productcategory_id: menuData.productcategory_id,
          productcategory_name: menuData.productcategory_name,
        });

        const selectedIds = menuData.products
          .flatMap(prod => prod.items || [])
          .map(item => item.item_id);

        const updatedSelected = currentProductId === forcedProductId
          ? [...new Set([...selectedIds, ...forcedItemIds])]
          : selectedIds;

        setSelectedItems(updatedSelected);

        const res = await axios.get(`${baseURL}/menumaker/item/products/grouped-by-product-item-category`, {
          params: {
            product_id: currentProductId,
            menumaker_date: formattedDate,
            sno: selectedSno,
          }
        });

        const grouped = res.data?.data;
        setGroupedProducts(grouped ? [grouped] : []);
        setProductImage(res.data?.data?.product_image || null);
      } catch (error) {
        console.error('Failed to load edit menu:', error);
      }
    };

    fetchEditData();
  }, [show, selectedSno, selectedDate]);

  const handleCheckboxChange = (itemId) => {
    const isForcedItem =
      productInfo?.product_id === forcedProductId && forcedItemIds.includes(itemId);

    if (isForcedItem) return;

    setSelectedItems(prev =>
      prev.includes(itemId)
        ? prev.filter(id => id !== itemId)
        : [...prev, itemId]
    );
  };

  const handleSubmit = async () => {
    if (!productInfo || !selectedDate || selectedItems.length === 0) return;

    const formattedDate = selectedDate.toLocaleDateString('sv-SE');

    const payload = {
      product_id: productInfo.product_id,
      productcategory_id: productInfo.productcategory_id,
      menumaker_date: formattedDate,
      item_ids: selectedItems,
    };

    try {
      setLoading(true);
      await axios.post(`${baseURL}/menumaker/${selectedSno}`, payload);
      onClose();
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Failed to update. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const formatDateDay = () => {
    if (!selectedDate) return '';
    const options = { day: '2-digit', month: 'short', year: 'numeric', weekday: 'long' };
    return selectedDate.toLocaleDateString('en-IN', options);
  };

  const allCategories = groupedProducts.flatMap(product => {
    const rawCategories = product.item_categories || [];
    return Array.isArray(rawCategories) ? rawCategories : Object.values(rawCategories);
  });

  const hasItems = allCategories.some(cat =>
    cat.item_sub_categories?.some(sub => sub.items?.length > 0)
  );

  return (
    <Modal className="modal fade" show={show} size="lg" onHide={onClose}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Edit Menu</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>

        <div className="modal-body">
           <div className="row">
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Product Category</label>
                            <label className='text-danger fs-6 font-w500'>{productInfo?.productcategory_name}</label>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <div className='d-flex flex-row gap-3 align-items-center justify-content-center'>
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]} 
                                >
                                    <div data-src={productImage || break_box} className='border rounded px-1 py-0'>
                                        <img src={productImage || break_box} className='cursor-pointer w-45px h-45px' />
                                    </div>
                                </LightGallery>
                                <div className='d-flex flex-column'>
                                    <label className='text-gray-800 font-w500 fs-7'>Product</label>
                                    <label className='text-danger fs-6 font-w500'>{productInfo?.product_name}</label>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Date & Day</label>
                            <label className='text-danger fs-6 font-w500'>{formatDateDay()}</label>
                        </div>
            </div>

          {/* <div className="row mb-3">
            <div className="col-lg-4">
              <label className="text-gray-800 font-w500 fs-7">Product Category</label>
              <div className="text-danger fs-6 font-w500">{productInfo?.productcategory_name}</div>
            </div>
            <div className="col-lg-4">
              <label className="text-gray-800 font-w500 fs-7">Product Name</label>
              <div className="text-danger fs-6 font-w500">{productInfo?.product_name}</div>
            </div>
            <div className="col-lg-4">
              <label className="text-gray-800 font-w500 fs-7">Date & Day</label>
              <div className="text-danger fs-6 font-w500">{formatDateDay()}</div>
            </div>
          </div> */}

          <label className="text-black fs-6 font-w500 mb-2">Update Selected Items</label>
          <div className="mh-350px py-2" style={{
    maxHeight: '350px',
    overflowY: 'auto',
    overflowX: 'hidden', // ⛔ explicitly block horizontal scroll
  }}>
            {!hasItems ? (
              <div className="text-muted">No items found for this product category.</div>
            ) : (
              allCategories.map(cat => ( 
                <div key={cat.item_category_id} className="mb-3">
                  <label className="fs-6 text-primary mb-1 font-w600">{cat.item_category_name}</label>

                  {Array.isArray(cat.item_sub_categories) && cat.item_sub_categories.length > 0 ? (
                    cat.item_sub_categories.map(sub => (
                      <div key={sub.item_sub_category_id} className="mb-2 ms-2">
                        <div className="text-muted fs-7 mb-1">{sub.item_sub_category_name}</div>
                        <div className="row">
                          {Array.isArray(sub.items) && sub.items.length > 0 ? (
                            sub.items.map(item => {
                              const isForced = productInfo?.product_id === forcedProductId && forcedItemIds.includes(item.item_id);
                              const isChecked = selectedItems.includes(item.item_id) || isForced;

                              return (
                                <div key={item.item_id} className="col-lg-4">
                                  <div className="form-check-inline mt-2">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      value={item.item_id}
                                      checked={isChecked}
                                      onChange={() => handleCheckboxChange(item.item_id)}
                                      disabled={isForced}
                                    />
                                    {/* <label className="fs-7 text-black mb-0 font-w500">
                                      {item.item_name}
                                    </label> */}

                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id={`tooltip-${item.item_id}`}>
                                          {item.item_name}
                                        </Tooltip>
                                      }
                                    >
                                      <label className="fs-7 text-black mb-0 font-w500" style={{ cursor: 'pointer' }}>
                                        {item.item_name.length > 15
                                          ? `${item.item_name.slice(0, 15)}...`
                                          : item.item_name}
                                      </label>
                                    </OverlayTrigger>


                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div className="col-12 text-muted">No items found in this subcategory.</div>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-muted fs-7 ms-2">No subcategories found.</div>
                  )}
                </div>
              ))
            )}
          </div>

          <div className="d-flex justify-content-end gap-3 mt-4">
            <Button className="btn btn-sm btn-primary" onClick={handleSubmit} disabled={loading}>
              {loading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Updating Menu Maker...
                </>
              ) : (
                <>
                  Update Menu Maker<i className="fas fa-angle-double-right ms-2" />
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditMenuItem;
